import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Hero banner',
    defaultMessage: 'Hero banner',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  eventFieldset: {
    id: 'Event info',
    defaultMessage: 'Event info',
  },
  ctaFieldset: {
    id: 'Call to action',
    defaultMessage: 'Call to action',
  },
  backgroundFieldset: {
    id: 'Background',
    defaultMessage: 'Background',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  subtitle: {
    id: 'Subtitle',
    defaultMessage: 'Subtitle',
  },
  infoItems: {
    id: 'Info items',
    defaultMessage: 'Info items',
  },
  infoItem: {
    id: 'Info item',
    defaultMessage: 'Info item',
  },
  infoItemLabel: {
    id: 'Label',
    defaultMessage: 'Label',
  },
  infoItemValue: {
    id: 'Value',
    defaultMessage: 'Value',
  },
  ctaLabel: {
    id: 'Button label',
    defaultMessage: 'Button label',
  },
  ctaLink: {
    id: 'Button link',
    defaultMessage: 'Button link',
  },
  backgroundImage: {
    id: 'Background image',
    defaultMessage: 'Background image',
  },
});

export const InfoItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.infoItem),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['label', 'value'],
    },
  ],
  properties: {
    label: {
      title: intl.formatMessage(messages.infoItemLabel),
      type: 'string',
    },
    value: {
      title: intl.formatMessage(messages.infoItemValue),
      type: 'string',
      widget: 'textarea',
    },
  },
  required: [],
});

/**
 * Schema do bloco Hero banner.
 * Todos os textos são editáveis (requisito do projeto).
 * Redes sociais virão de control panel global (fora do escopo — ver
 * docs/specs/schema-decisions.md §1).
 */
const HeroBannerSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['title', 'subtitle'],
    },
    {
      id: 'event',
      title: intl.formatMessage(messages.eventFieldset),
      fields: ['infoItems'],
    },
    {
      id: 'cta',
      title: intl.formatMessage(messages.ctaFieldset),
      fields: ['ctaLabel', 'ctaLink'],
    },
    {
      id: 'background',
      title: intl.formatMessage(messages.backgroundFieldset),
      fields: ['backgroundImage'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
    },
    subtitle: {
      title: intl.formatMessage(messages.subtitle),
      type: 'string',
      widget: 'textarea',
    },
    infoItems: {
      title: intl.formatMessage(messages.infoItems),
      widget: 'object_list',
      schema: InfoItemSchema({ intl }),
    },
    ctaLabel: {
      title: intl.formatMessage(messages.ctaLabel),
      type: 'string',
    },
    ctaLink: {
      title: intl.formatMessage(messages.ctaLink),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
    backgroundImage: {
      title: intl.formatMessage(messages.backgroundImage),
      widget: 'image',
    },
  },
  required: [],
});

export default HeroBannerSchema;
